export function initializeBrushSystem(deps) {
    const { BrushSystem, BrushUI, BrushOptimizer } = deps || {};
    try {
        this.brushSystem = new BrushSystem(this);
        this.brushUI = new BrushUI(this.brushSystem, this);
        this.brushOptimizer = new BrushOptimizer(this.brushSystem);

        this.updateStatus?.('Brush system ready');
    } catch (error) {
        console.error('Failed to initialize brush system:', error);
        this.updateStatus?.('Error: Failed to initialize brush system');
    }
}
